import { useMutationErrorHandler } from '../../../../hooks/useMutationErrorHandler';
import { useSerialProcessing } from '../../../../hooks/useSerialProcessing';
import { useRejectTimeEntryChangeRequest } from './useApproveRejectTimeEntryChangeRequestMutations';

export const useRejectTimeEntryChangeRequestSerial = () => {
  const [batchReject] = useRejectTimeEntryChangeRequest();
  const errorHandler = useMutationErrorHandler();

  return useSerialProcessing(
    (ids: string[]) => {
      return batchReject({
        variables: {
          input: { ids },
        },
      })
        .catch(errorHandler)
        .then();
    },
    {
      batchSize: 5,
    },
  );
};
